module.exports = __webpack_public_path__ + "img/success@2x.f3d061ca.png";